<template>
    <div style="height: 100%;width: 100%;background-color: #FCFCFC;">
        <div
            style="width: 100%;height: 60px;background-color: #409EFF;display: flex;align-items: center;position: relative;">
            <div style="width: 30px;height: 30px;margin-left: 20px;" v-if="winWidth < 600" @click="openDrawer">
                <img src="https://txcloud.aojuai.com/icon/aojv/aiwx_icon/gdlb.png" alt=""
                    style="width: 100%;height: 100%;">
            </div>
            <div style="height: 45px;margin-left: 20px;font-size: 28px;font-weight: 600;color: white;text-align: center;"
                v-if="winWidth > 600">
                Ai智能场景演练
            </div>
            <div class="aoju_title">
                <div :style="{ width: winWidth < 600 ? '100%' : '65%' }"
                    style="margin: 0 auto;text-align: center;color: white;">
                    {{ diaArr.length > 1 ? diaArr[1].conter : '新演练' }}
                </div>
            </div>
            <div style="font-size: 23px;font-weight: 600;color: white;position: absolute;
            top: 0px;right: 40px;height: 60px;line-height: 60px;" @click="gotoPath">大屏展示</div>
        </div>
        <div style="width: 100%;display: flex;height: 100%;">
            <div style="width: 500px;height:calc(100% - 70px);background-color:#F5F5F5;overflow: hidden;"
                v-if="winWidth > 600">
                <el-tabs type="border-card" v-model="tabsIndex" stretch @tab-click="handleClick">
                    <el-tab-pane name="1" style="width: 100%;height: 100%;">
                        <span slot="label">
                            <i class="el-icon-date"></i> 我的演练</span>
                        <div style="width: 100%;height: 100%;">
                            <div style="width: 100%;position: relative;">
                                <div
                                    style="position: absolute;top: -20px;right: -20px;width:120px;height:100px;z-index: 0;">
                                    <el-image width="100%" height="100%"
                                        src="https://txcloud.aojuai.com/icon/aojv/aiwx_icon/mytraining_img.png" />
                                </div>
                                <div style="width: 95%;margin: 20px auto 5px;overflow: hidden;background-repeat: no-repeat;background-size:contain; height: 220px;border-radius: 10px;
                    background-image: url('https://txcloud.aojuai.com/icon/aojv/aiwx_icon/training_bg.png');">

                                    <div
                                        style="display: flex;margin-left: 15px;height: 50px;line-height: 50px;align-items: center;margin-top: 15px;">
                                        <div style="width: 30px;height: 30px;">
                                            <el-image width="100%" height="100%"
                                                src="https://txcloud.aojuai.com/icon/aojv/aiwx_icon/training_icon.png" />
                                        </div>
                                        <div style="font-size: 18px;color: #24355E;margin:0 15px;font-weight: bold;">
                                            训练数据
                                        </div>

                                    </div>
                                    <div
                                        style="width:95%;height: 140px;margin: 5px auto;background-color: white;border-radius: 10px;z-index: 10;">
                                        <div
                                            style="display: flex;justify-content: space-around;height:100%;align-items: center;width: 100%;">
                                            <div
                                                style="display: flex;flex-direction: column;justify-content: center;align-items: center;height: 100%;">
                                                <div style="color:black;font-size: 14px;">总训练次数</div>
                                                <div
                                                    style="color:black;font-size: 19px;font-weight: 600;margin-top: 25px;">
                                                    {{ traniningTj.count || '0' }}</div>
                                            </div>
                                            <div
                                                style="display: flex;flex-direction: column;justify-content: center;align-items: center;height: 100%;">
                                                <div style="color:black;font-size: 14px;">分均分数</div>
                                                <div
                                                    style="color:black;font-size: 19px;font-weight: 600;margin-top: 25px;">
                                                    {{ traniningTj.scoreAverage || '0' }}</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="height: 1px;width: 90%;margin: 5px auto;background-color: #E4E7ED;"></div>
                            <div style="width: 90%;height: 40px;margin: 5px auto;background-color: #E8ECFD;border-radius: 20px;
                                display: flex;align-items: center;justify-content: space-around;">
                                <div style="width: 35%;height: 30px;line-height: 30px;color: black;font-size: 15px;border-radius: 20px;text-align: center;"
                                    :style="{ 'backgroundColor': MyTrainIndex == 2 ? '#409EFF' : '#E8ECFD', 'color': MyTrainIndex == 2 ? 'white' : 'black' }"
                                    @click="MyTrainRecordTabChange(2)">
                                    已完成
                                </div>
                                <div style="width: 35%;height: 30px;line-height: 30px;color: black;font-size: 15px;border-radius: 20px;text-align: center;"
                                    :style="{ 'backgroundColor': MyTrainIndex == 1 ? '#409EFF' : '#E8ECFD', 'color': MyTrainIndex == 1 ? 'white' : 'black' }"
                                    @click="MyTrainRecordTabChange(1)">
                                    未完成
                                </div>
                            </div>
                            <div style="width: 100%;overflow: auto;height: calc(100% - 400px);">
                                <template v-for="(item, index) in trainingList">
                                    <div class="zhushou_center">
                                        <div class="zhushou_img">
                                            <el-image width="80px" fit="fill" height="80px" :src="item.yatbCover" />
                                        </div>
                                        <div class="zhushou_title">
                                            <div style="font-size: 16px;font-weight: bold;">
                                                <el-image width="20px" fit="fill" height="20px"
                                                    src="https://txcloud.aojuai.com/icon/aojv/aiwx_icon/hot_icon.png"
                                                    style="vertical-align: middle;" />{{ item.yatbTitle || '' }}
                                            </div>
                                            <div
                                                style="margin:5px 0; font-size: 12px;color: #447EFB;border: 1px solid #447EFB;border-radius: 20px;width: 80px;text-align: center;">
                                                {{ item.yatcName || '' }}</div>
                                            <div style="font-size: 13px; color: #919191;">{{ item.createtime }}</div>
                                        </div>
                                        <div style="margin: 0 5px;width: 100px;" v-if="item.yatuStatus == 2">
                                            <el-button type="success" round size="small" style="font-size: 12px;"
                                                @click="MyTraining(item)">本次训练复盘</el-button>
                                        </div>
                                    </div>
                                </template>

                            </div>
                            <div style="width: 80%;height: 50px;line-height: 50px;text-align: center;border-radius: 5px;background-color: #409EFF;font-size: 20px;font-weight: 600;color: white;margin: 10px auto;"
                                @click="outLogin">
                                退出登录
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="2" style="width: 100%;height: 100%;">
                        <span slot="label">
                            <i class="el-icon-date"></i>演练场景</span>
                        <div style="width: 100%;height: calc(100% - 150px);overflow: auto;">
                            <el-collapse accordion style="width: 95%;margin: 10px auto;" v-model="weikeTab">
                                <el-collapse-item v-for="(item, index) in weikeMsg" :key="index" :name="item.yatcId">
                                    <template slot="title">
                                        <div style="display: flex;align-items: center;height: 25px;">
                                            <el-image
                                                style="width: 5px;height: 20px;vertical-align: middle;margin-left: 10px;"
                                                src="https://trainapp.aojuai.com/wx/image/tabbar5/cy.png" />
                                            <div
                                                style="font-size: 20px;font-weight: 600;margin-left: 10px;line-height: 25px;">
                                                {{ item.yatcName }}
                                            </div>
                                        </div>
                                    </template>
                                    <div style="width: 100%;padding: 10px;">
                                        <el-tabs tab-position="left" v-model="AiScencTab"
                                            @tab-click="AiScenc_typeChange(item.yatcId)" stretch
                                            style="min-height: 200px;">
                                            <template v-for="(AiScencItem, AiScencIndex) in AiScencList || []">
                                                <el-tab-pane :name="AiScencItem.yatcId + ''" lazy>
                                                    <span slot="label"><i class="el-icon-date"></i> {{
                                                        AiScencItem.yatcName }}</span>
                                                    <template v-for="(miniclassItem, miniclassIndex) in miniclassList">
                                                        <div style="margin: 15px 0;">
                                                            <div style="width: 95%; height: 100px; border-radius: 0px; margin: 10px auto;background-color: #F1F6FF; overflow: hidden;display: flex;align-items: center;justify-content: space-around;"
                                                                @click="theTrainingChange(miniclassItem)">
                                                                <div
                                                                    style="width: 30%;height: 100%;display: flex;align-items: center;justify-content: center;padding: 10px;">
                                                                    <el-image :src="miniclassItem.yatbCover"
                                                                        style="margin-top: 10rpx;width: 80px;height: 80px;border-radius: 15px;" />
                                                                </div>
                                                                <div
                                                                    style="width: 65%;height: 100%;margin-left: 1%;margin-top: 10px;display: flex;flex-direction: column;justify-content: center;">
                                                                    <div
                                                                        style="width: 100%;font-size: 15px;font-weight: 500;margin-top: 10px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">
                                                                        {{ miniclassItem.yatbTitle }}</div>
                                                                    <div
                                                                        style="display: flex;align-items: center;margin-top: 5px;">
                                                                        <el-image
                                                                            style="width: 14px;height: 14px;vertical-align: middle;"
                                                                            src="https://txcloud.aojuai.com/icon/aojv/icon/lookNumBg.png" />
                                                                        <div
                                                                            style="color: #CED0D1;font-size: 13px;height: 15px;line-height: 15px;margin-left: 5px;">
                                                                            {{ miniclassItem.yatbTrainNum }}</div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </template>
                                                </el-tab-pane>
                                            </template>

                                        </el-tabs>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </el-tab-pane>
                </el-tabs>


            </div>
            <div :style="{ width: winWidth < 600 ? '100%' : 'calc(100% - 500px)' }" style="position: relative;"
                v-if="tabsIndex == 2">
                <div class="mainDiv mainDivHeight" style="width: 65%;margin: 0 auto;overflow-y: auto;">
                    <template v-for="(item, index) in diaArr">
                        <div v-if="item.type == 1 || item.type == 3 || item.type == 4">
                            <div :class="[item.type == 4 ? 'egclass' : 'message']">
                                <div v-if="item.type == 3">
                                    {{ item.conter }}
                                    <span>{{ loadingText }}</span>
                                </div>
                                <div v-if="item.type == 1 || item.type == 4" v-html="item.conter"
                                    style="width: 100%;line-height: 30px;">
                                </div>
                                <!-- <div v-if="item.type == 1 && item.stop"
                                    style="width: 100%;margin: 20px 0 0;display: flex;align-items: center;">
                                    <div @click="conterCopy(index)">
                                        <i class="el-icon-copy-document"
                                            style="font-size: 24px;color: #909399;margin: 0 15px;"></i>
                                    </div>
                                    <div @click="restConter(index)">
                                        <i class="el-icon-refresh"
                                            style="font-size: 24px;color: #909399;margin: 0 15px;"></i>
                                    </div>
                                </div> -->

                                <div v-if="item.type == 4" class="egTitleclass">
                                    演练开始,请做好准备~</div>
                            </div>
                        </div>
                        <div class="flex-right"
                            style="display: flex;align-items: flex-end;flex-direction: column;margin-right: 10px;"
                            v-if="item.type == 2">
                            <div class="message2" style="color: white;">
                                {{ item.conter }}
                            </div>
                        </div>
                    </template>
                    <div style="width: 100%;" :style="{ 'height': isTraining == 2 ? '300px' : '0' }">
                        <div ref="eCharts1" style="width: 100%;height: 100%; margin: 20px auto;"></div>
                    </div>
                    <div style="height: 130px;"></div>
                </div>
                <!-- 输入框 -->
                <div class="inputDiv"
                    style="display: flex;flex-direction: column;align-items: center;justify-content: center;background-color: white;"
                    v-if="isTraining == 1">
                    <div style="width: 100%;height: 55%;padding: 10px;">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" placeholder="请开始您的回答!"
                            :disabled="btnDisabled" clearable v-model="query" style="border: none;">
                        </el-input>
                    </div>
                    <div
                        style="width: 100%;height: 50px;display: flex;align-items: center;flex-direction: row-reverse;padding-right: 20px;">
                        <div class="iconStyle" style="display: flex;align-items: center;justify-content: center;border-radius: 100%;border: 1px solid #EBEEF5;
                 box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);" @click="inputSub">
                            <div>
                                <i class="el-icon-s-promotion"></i>
                            </div>
                        </div>
                        <!-- <div class="iconStyle" style="display: flex;align-items: center;justify-content: center;border-radius: 100%;border: 1px solid #EBEEF5;
                 box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);" @click="abortStream"
                            v-if="isOpen">
                            <div class="iconStyle_icon">
                                <el-image src="https://txcloud.aojuai.com/icon/ajtools.cn/tools/stop.png"
                                    style="width: 100%;height: 100%;vertical-align:top;"></el-image>
                            </div>
                        </div> -->
                        <!-- <div class="iconStyle" style="display: flex;align-items: center;justify-content: center;border-radius: 100%;border: 1px solid #EBEEF5;
                 box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);" @click="createNewChat">
                            <div>
                                <i class="el-icon-plus"></i>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div style="width: 100%;height: 100%;position: absolute;top: 0;left: 0;background: rgba(255, 255, 255, 0.2);backdrop-filter: blur(10px);display: flex;align-items: center;justify-content: center;"
                    v-if="isTraining == 0">
                    <div style="width: 100%;font-size: 25px;font-weight: 600;color: #F56C6C;text-align: center;"
                        v-if="!theItem">
                        请先选择您想要演练的场景
                    </div>
                    <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;"
                        v-if="theItem">
                        <div
                            style="width: 100px;height: 100px;border-radius: 10px;border: 3px solid #409EFF;padding: 5px;">
                            <el-image style="width: 100%;height: 100%;" :src="theItem.yatbCover"></el-image>
                        </div>
                        <div style="margin: 15px 0;font-size: 22px;font-weight: 600;color: #409EFF;text-align: center;">
                            {{ theItem.yatbTitle }}
                        </div>
                        <div>
                            <el-button type="primary" size="small" @click="createInit()"
                                style="font-size: 18px;width: 120px;">开始演练</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div :style="{ width: winWidth < 600 ? '100%' : 'calc(100% - 500px)' }" style="position: relative;"
                v-if="tabsIndex == 1">
                <div class="mainDiv mainDivHeight" style="width: 65%;margin: 0 auto;overflow-y: auto;"
                    v-if="myTrainingMsg && myTrainingMsg.ycAiTrainUserMsgList">
                    <div v-html="myTrainingMsg.ycAiTrainUserMsgList[myTrainingMsg.ycAiTrainUserMsgList.length - 1].yuamrAnswer"
                        style="width: 100%;line-height: 30px;">
                    </div>
                    <div style="width: 100%;" :style="{ 'height': myTrainingMsg.yuamrAnswerEvaluate ? '300px' : '0' }">
                        <div ref="eCharts1" style="width: 100%;height: 100%; margin: 20px auto;"></div>
                    </div>
                </div>
                <div style="width: 100%;height: 100%;position: absolute;top: 0;left: 0;background: rgba(255, 255, 255, 0.2);backdrop-filter: blur(10px);display: flex;align-items: center;justify-content: center;"
                    v-if="!theScItem">
                    <div style="width: 100%;font-size: 25px;font-weight: 600;color: #F56C6C;text-align: center;">
                        请先选择您已完成的训练记录
                    </div>
                </div>
            </div>
        </div>

        <el-drawer :visible.sync="isDrawer" :with-header="false" direction="ltr" size="80%">
            <div style="width: 500px;height:100%;background-color:#F5F5F5;">
                <div style="width: 80%;background-color: white;height: 50px;border-radius: 10px;margin: 10px auto;
                box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);line-height: 50px;text-align: center;"
                    @click="createNewChat">
                    <i class="el-icon-plus" style="font-size: 20px;margin-right: 5px;"></i>
                    <span style="font-size: 15px;font-weight: 500;">新建对话</span>
                </div>
                <div style="height: 1px;width: 90%;margin: 10px auto;background-color: #E4E7ED;"></div>
                <div style="width: 100%;overflow: auto;height: calc(100% - 160px);">
                    <div style="margin: 10px;font-size: 15px;">历史对话:</div>
                    <div style="width: 100%;margin: 10px auto;">
                        <template v-for="(item, index) in DiaHisList">
                            <div style="width: 90%;margin:10px auto;background-color: #DCDFE6;position: relative;border-radius: 5px;overflow: hidden;"
                                :style="{ border: tapIndex == index ? '2px solid #409EFF' : 'none' }"
                                @click="DiaHisClick(item, index)">
                                <div
                                    style="width: 88%;margin-left: 10px;margin-top: 5px; font-size: 12px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                    {{ item.chatTitle }}</div>
                                <div
                                    style="width: 88%;margin-left: 10px;margin-top: 5px;font-size: 11px;color: #606266;">
                                    {{ item.createtime }}</div>
                                <div style="position: absolute;top: 10px;right: 10px;"
                                    @click="delDiaHisClick(item, indexedDB)">
                                    <i class="el-icon-delete-solid" style="font-size: 16px;"></i>
                                </div>
                            </div>
                        </template>

                    </div>
                </div>
                <div style="width: 80%;height: 50px;line-height: 50px;text-align: center;border-radius: 5px;background-color: #409EFF;font-size: 20px;font-weight: 600;color: white;margin: 10px auto;"
                    @click="outLogin">
                    退出登录
                </div>
            </div>
        </el-drawer>
        <div style="width: 100%;height: 100%;background-color: rgba(7, 6, 6,0.5);position: fixed;top: 0;display: flex;align-items: center;justify-content: center;z-index: 100;"
            v-if="isLogin">
            <div class="login-container">
                <h2>Ai智能场景演练</h2>
                <form @submit.prevent="handleSubmit">
                    <div class="form-group">
                        <label for="username">用户名</label>
                        <input type="text" id="username" v-model="userAccount" required />
                    </div>
                    <div class="form-group">
                        <label for="password">密码</label>
                        <input type="password" id="password" v-model="password" required />
                    </div>
                    <button type="submit">登录</button>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
import {
    doLoginAiTrain, getAiUserChatList, deleteAiUserChatOne, getAiUserChatMsgListHistory, getAiKnowledgeFileUser,
    getAiUserChatAuth, getAiUserChatOne, addYcAiTrainUserMsg, deleteAiUserChat, addAiUserChatOne, getUserProjectRecordLast,
    getYcAiTrainUserStatisticsMine, getYcAiTrainUserList, getYcAiTrainClassList, getYcAiTrainBaseList, addYcAiTrainUser, getYcAiTrainUserDetails
} from "../api/api";
import { mapState, mapMutations, mapAction } from 'vuex'
import MarkdownIt from 'markdown-it';
var FileSaver = require('file-saver');
const md = new MarkdownIt(); // 创建markdown-it实例
md.core.ruler.push('single_star', function (state) {
    for (let i = 0; i < state.tokens.length; i++) {
        if (state.tokens[i].type === 'text' && state.tokens[i].content === '*') {
            state.tokens[i].type = 'html_inline';
            state.tokens[i].content = '<span class="single-star">*</span>';
        }
    }
    return true;
});
// 自定义规则处理 \n 换行
md.renderer.rules.text = function (tokens, idx, options, env, self) {
    let text = tokens[idx].content;
    text = text.replace(/\n/g, '<br>');
    return text;
};
// 处理换行符
md.renderer.rules.paragraph_open = function (tokens, idx, options, env, self) {
    return '<p class="markdown-paragraph">';
};
import * as echarts from 'echarts';
import router from "../router";

export default {

    name: '',
    components: {

    },
    data() {
        return {
            theScItem: '',
            myTrainingMsg: '',
            color: [
                " #4992ff",
                " #dd79ff",
                " #fddd60",
                "  #ff6e76",
                " #58d9f9",
                " #05c091",
                "  #ff8a45",
                " #8d48e3"
            ],
            echartsStr: "",
            echartsStrValue: [],
            firstArray: [],
            secondArray: [],
            isTraining: 0,//是否演练中 0-否 1-是
            theItem: null,//演练场景
            theYatbId: null,//演练场景id
            miniclassList: [],//场景二级分类下-场景
            AiScencTab: '0',//场景二级分类tab
            AiScencList: [],//场景二级分类
            weikeTab: '',//场景一级分类tab
            weikeMsg: [],//场景一级分类
            trainingList: [],
            MyTrainIndex: 2,
            tabsIndex: '2',
            traniningTj: {
                count: 0,
                scoreAverage: 0,
            },
            api_url: 'https://qianfan.baidubce.com',
            isDrawer: false,
            activeNames: [],
            aucStatus: 1,
            tapIndex: 0,
            DiaHisList: [],

            controller: null,
            isOpen: false,
            mergeArr: [],
            isMerge: false,
            ThinkIndex: 0,
            DmxIndex: 0,
            AnswerMsg: '',
            ThinkMsg: '',
            ArgChat: [],
            WxAiChatSession: [],
            theConversationId: '',
            btnDisabled: false,
            timeID: null,
            loadingNums: 0,
            loadingText: '',

            query: '',
            winWidth: '',
            isLogin: true,
            jqr2: 'https://txcloud.aojuai.com/icon/aojv/aiwx_icon/jqr2.png',
            diaArr: [
                {
                    type: 4, //1.是答,2.是问
                    HanderImg: "https://txcloud.aojuai.com/icon/aojv/icon/ai.png",
                    conter: '',

                }
            ],
            AnswerIndex: 0,
            userAccount: '',
            password: '',
            userMsg: {
                userAccount: '',
                password: ''
            },

        }
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                this.winWidth = val
            });
        },
    },
    created() {
        document.title = 'Ai智能场景演练';
        this.winWidth = window.innerWidth;
        if (localStorage.getItem('AiTrainingMsg')) {
            this.isLogin = false
            if (this.tabsIndex == '1') {
                this.MyTrainRecord()
            } else {
                this.AiSCenc()
            }
        } else {
            this.isLogin = true
        }
    },
    mounted() {
        // 监听键盘事件
        window.addEventListener('keydown', this.keyDown)
    },
    destroyed() {
        window.removeEventListener('keydown', this.keyDown, false)
    },
    activated() {

    },
    methods: {
        MyTraining(item) {
            this.theScItem = item
            getYcAiTrainUserDetails({ yatuId: item.yatuId }).then(res => {
                if (res.data.yuamrAnswerEvaluate && res.data.yuamrAnswerEvaluate != '{}') {
                    var yuamrAnswerEvaluate = JSON.parse(res.data.yuamrAnswerEvaluate)
                    console.log(yuamrAnswerEvaluate);
                    if (yuamrAnswerEvaluate[0].firstArray && yuamrAnswerEvaluate[0].firstArray.length > 0) {
                        this.firstArray = yuamrAnswerEvaluate[0].firstArray;
                        this.secondArray = yuamrAnswerEvaluate[0].secondArray;
                        this.echartsStrValue = {
                            xdata: [],
                            data: []
                        };
                        this.$nextTick(() => {
                            this.initEcharts()
                        })
                        this.isTraining = 2;
                    }
                }
                this.myTrainingMsg = res.data;
            })
        },
        gotoPath() {
            console.log('1');
            // 跳转到大屏
            this.$router.push({
                path: '/BigSceen'
            })
        },
        initEcharts() {
            var that = this
            var maxNum = "";
            that.echartsStrValue.xdata = that.secondArray
            that.firstArray.forEach(
                (items, index) => {
                    that.echartsStrValue.data.push({
                        name: items,
                        max: ""
                    });
                }
            );
            maxNum = Math.max(...that.echartsStrValue.xdata);
            that.echartsStrValue.data.forEach(item => {
                item.max = maxNum;
            });

            if (that.isTraining == 2) {
                console.log(echarts);
                that.$nextTick(() => {
                    that.echartsStr.resize()
                })
                that.echartsStr = echarts.init(that.$refs.eCharts1);
                that.echartsStr.setOption({
                    darkMode: " auto",
                    colorBy: "series",
                    color: that.color,
                    // backgroundColor: '#100C2A',


                    tooltip: {
                        trigger: "item"
                    }, //提示框组件 ---数据项图形触发
                    legend: {
                        // orient: 'vertical', //图标列表的布局朝向
                        right: "3%",
                        top: "3%",
                        data: ["训练分析"]
                    },
                    radar: {
                        // shape: 'circle',
                        indicator: that.echartsStrValue.data
                    },
                    series: [
                        {
                            type: "radar",
                            radius: "100%",
                            data: [
                                {
                                    value: that.echartsStrValue.xdata,
                                    name: ""
                                }
                            ],

                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: "rgba(0, 0, 0, 0.5)"
                                }
                            }
                        }
                    ]
                });

            }


        },
        AiScenc_typeChange(e) {
            console.log(e);
            getYcAiTrainClassList({ yatcParentId: e * 1 }).then(res => {
                this.AiScencList = res.data;
                this.AiScencTab = res.data[0].yatcId + '';
                this.AiScencList.forEach(element => {
                    element.yatcId = element.yatcId + ''
                });
                getYcAiTrainBaseList({ yatcId: res.data[0].yatcId * 1 }).then(ress => {
                    this.miniclassList = ress.data;
                })
            })
        },
        AiSCenc() {
            this.isTraining = 0;
            this.theItem = '';
            this.theYatbId = '';
            getYcAiTrainClassList().then(res => {
                this.weikeMsg = res.data;
                this.weikeTab = res.data[0].yatcId;
                this.AiScenc_typeChange(res.data[0].yatcId)

            })
        },
        handleClick(e) {
            if (this.tabsIndex == '1') {
                this.MyTrainRecord()
            } else {
                this.AiSCenc()
            }
        },
        MyTrainRecordTabChange(val) {
            this.MyTrainIndex = val
            getYcAiTrainUserList({ yatuStatus: val }).then(res => {
                this.trainingList = res.data;
            })
        },
        MyTrainRecord() {
            getYcAiTrainUserStatisticsMine().then(res => {
                this.traniningTj = res.data;
                this.MyTrainRecordTabChange(this.MyTrainIndex)
            })
        },
        outLogin() {
            this.$confirm('是否确认退出登录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                localStorage.removeItem('AiTrainingMsg')
                this.isLogin = true
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        openDrawer() {
            this.isDrawer = true;
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        DownFile(item) {
            this.openLoading()
            getAiKnowledgeFileUser({
                akwName: item.dataset_name,
                akfName: item.document_name
            }).then(res => {
                const suffix = item.document_name;
                FileSaver.saveAs(res.data.akfPath, suffix)
                this.loadings.close()
                // 下载成功
                this.$message({
                    showClose: true,
                    message: '下载成功',
                    type: 'success'
                });
            })

        },
        handleChange(val) {
            console.log(val);
        },
        // 创建新对话
        createNewChat() {
            // 是否确认开启新对话?
            this.$confirm('是否确认开启新对话?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                addAiUserChatOne({ aaAppId: this.WxAiChatSession.aaAppId, }).then(res => {
                    this.WxAiChatSession = res.data;
                    this.AnswerIndex = 0;
                    this.diaArr = [{
                        type: 4, //1.是答,2.是问
                        HanderImg: "https://txcloud.aojuai.com/icon/aojv/icon/ai.png",
                        conter: '竭诚为您提供政企领域的营销支撑，您在营销过程中遇到的流程、产品、营销相关的问题，我都可以为您提供专业建议。您提供的信息越详细，我就能给出更精准、更有价值的建议。让我们一起提升营销效果，创造更好的业绩！',
                        eg: [{
                            text: '酒店客户可以推荐什么产品？'
                        }, {
                            text: '商务楼宇的物业怎么进行攻坚？'
                        },]
                    }];
                    this.aucStatus = 1;
                    this.tapIndex = null;
                    this.btnDisabled = false;
                })



            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        DiaHisClick(item, index) {
            getAiUserChatMsgListHistory({ aucId: item.aucId }).then(res => {
                if (res.data.aiUserChatMsgList && res.data.aiUserChatMsgList.length > 0) {
                    this.tapIndex = index;
                    this.aucStatus = item.aucStatus;
                    this.WxAiChatSession = res.data;
                    this.diaArr = [{
                        type: 4, //1.是答,2.是问
                        stop: false,
                        HanderImg: "https://txcloud.aojuai.com/icon/aojv/icon/ai.png",
                        conter: '竭诚为您提供政企领域的营销支撑，您在营销过程中遇到的流程、产品、营销相关的问题，我都可以为您提供专业建议。您提供的信息越详细，我就能给出更精准、更有价值的建议。让我们一起提升营销效果，创造更好的业绩！',
                        eg: [{
                            text: '酒店客户可以推荐什么产品？'
                        }, {
                            text: '商务楼宇的物业怎么进行攻坚？'
                        },
                            //  {
                            //   text: '专线业务的合同管理要点？'
                            // },
                            // {
                            //   text: '我想上线一款政企产品，需要哪些工作流程？'
                            // }
                        ]
                    }]
                    res.data.aiUserChatMsgList.forEach(element => {
                        if (element.yuamrQuestion) {
                            const query = {
                                conter: element.yuamrQuestion,
                                type: 2
                            }
                            this.diaArr.push(query)
                            this.$set(this.diaArr, this.diaArr.length - 1, this.diaArr[this.diaArr.length - 1])
                            if (element.yuamrAnswer) {
                                const query = {
                                    conter: element.yuamrAnswer,
                                    think: element.yuamrThink ? element.yuamrThink : '',
                                    yuamrId: element.yuamrId ? element.yuamrId : '',
                                    type: 1,
                                    IsCollapse: true,
                                    IsFlieShow: false,
                                    stop: true,
                                }
                                this.diaArr.push(query)
                                this.isPopup = false;
                                this.theConversationId = element.conversationId
                                this.$set(this.diaArr, this.diaArr.length - 1, this.diaArr[this.diaArr.length - 1])
                            }
                        }
                    });
                }
            })
        },
        delDiaHisClick(item) {
            this.$confirm('是否删除该对话？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteAiUserChatOne({
                    aucId: item.aucId
                }).then(res => {
                    if (res.status == 200) {
                        getAiUserChatList().then(res => {
                            this.DiaHisList = res.data;
                            if (index == this.tapIndex) {
                                this.tapIndex = 0;
                                this.DiaHisClick(this.DiaHisList[0], 0)
                            }
                        })
                        this.$message({
                            showClose: true,
                            message: '删除成功',
                            type: 'success'
                        });
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 问答
        queryClick(val) {
            const myMsg = {
                type: 2,
                conter: val
            }
            const load = {
                type: 3,
                conter: '我正在努力思考，请稍等',
                stop: false,
            }
            this.diaArr.push(myMsg)
            this.diaArr.push(load)
            this.getTime();
            this.AnswerIndex = 0;
            this.btnDisabled = true;
            this.DmxInit(val)
        },
        // 重新问答
        restConter(index) {
            const qury = this.diaArr[index - 1].conter;
            const yuamrId = this.diaArr[index].yuamrId;
            if (yuamrId) {
                deleteAiUserChat({
                    yuamrId: yuamrId
                }).then(res => {
                    if (res.status == 200) {
                        this.diaArr.splice(index - 1, 2)
                        const myMsg = {
                            type: 2,
                            conter: qury
                        }
                        const load = {
                            type: 3,
                            conter: '我正在努力思考，请稍等',
                            stop: false,
                        }
                        this.diaArr.push(myMsg)
                        this.diaArr.push(load)
                        this.getTime();
                        this.AnswerIndex = 0;
                        this.btnDisabled = true;
                        this.DmxInit(qury)
                    }
                })
            } else {
                this.diaArr.splice(index - 1, 2)
                const myMsg = {
                    type: 2,
                    conter: qury
                }
                const load = {
                    type: 3,
                    conter: '我正在努力思考，请稍等',
                    stop: false,
                }
                this.diaArr.push(myMsg)
                this.diaArr.push(load)
                this.getTime();
                this.AnswerIndex = 0;
                this.btnDisabled = true;
                this.DmxInit(qury)
            }
        },
        // 复制文本
        conterCopy(index) {
            const textToCopy = this.diaArr[index].conter; // 获取要复制的文本
            const plainText = this.convertHtmlToText(textToCopy); // 转换为纯文本
            if (navigator.clipboard) {
                this.copyTextToClipboardUsingClipboardAPI(plainText);
            } else {
                this.copyTextToClipboardLegacy(plainText); // 使用旧的execCommand方法（不推荐）
            }
        },
        copyTextToClipboardUsingClipboardAPI(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.$message({
                    showClose: true,
                    message: '复制成功',
                    type: 'success'
                });
            }).catch(err => {
                console.error('复制失败:', err);
            });
        },
        copyTextToClipboardLegacy(text) {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed'; // 防止滚动到顶部
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                this.$message({
                    showClose: true,
                    message: '复制成功',
                    type: 'success'
                });
            } catch (err) {
                console.error('复制失败:', err);
            } finally {
                document.body.removeChild(textArea);
            }
        },
        // 大模型初始化
        DmxInit(val) {
            this.ThinkIndex = 0;
            this.DmxIndex = 0;
            this.AnswerMsg = '';
            this.ThinkMsg = '';
            this.AnswerIndex = 0;
            this.btnDisabled = true;
            this.requestTask_api(val)

        },
        // 中断请求
        abortStream() {
            if (this.controller) {
                this.controller.abort();
                this.isOpen = false;
                this.btnDisabled = false;

                // this.isStop = false;
                this.controller = null
            }
        },
        // 调用大模型的api
        async requestTask_api(val) {
            var that = this
            const str = {
                app_id: that.WxAiChatSession.appId,
                conversation_id: that.WxAiChatSession.conversationId,
                stream: true,
                query: val,
            }
            this.controller = new AbortController();
            const signal = this.controller.signal;
            try {
                // const response = await fetch(that.api_url +'/v2/app/conversation/runs', {
                // const response = await fetch('/api/v2/app/conversation/runs', {
                const response = await fetch('https://trainuser.aojuai.com/api/v2/app/conversation/runs', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json',
                        'X-Appbuilder-Authorization': that.WxAiChatSession.appSecret,
                    },
                    body: JSON.stringify(str), // 对象转为 JSON 字符串
                    // credentials: 'include',
                    // mode: 'no-cors',
                    signal
                })
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const reader = response.body.getReader(); // 获取流式读取器
                const decoder = new TextDecoder(); // 解码二进制数据为文本
                // console.log(decoder);
                while (true) {
                    const { done, value } = await reader.read(); // 逐块读取
                    if (done) break; // 流结束
                    const chunk = decoder.decode(value); // 解码为文本
                    // console.log('Received chunk:', chunk);
                    if (that.isMerge) {
                        that.mergeArr.push(chunk);
                        const mergeStr = that.mergeArr.join('');
                        var lines2 = mergeStr.split('\n'); // 假设每个数据项占一行，且用换行符分隔  
                        var dataItems2 = lines2.filter(line => line.startsWith('data: '));
                        var jsonObjects2 = dataItems2.map(item => {
                            // 移除每行开头的 "data: "
                            var jsonString2 = item.substring(6);
                            try {
                                // 将JSON字符串转换为对象  
                                return JSON.parse(jsonString2);
                            } catch (e) {
                                console.error("解析JSON时出错：", e, item);
                                return null;
                            }
                            // 将JSON字符串转换为对象  
                        });
                        if (jsonObjects2.length > 0) {
                            console.log(jsonObjects2);
                            jsonObjects2.forEach((item, index) => {
                                if (item && !item.is_completion) {
                                    if (item.content[0].event_type == 'ChatAgent') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1;
                                        console.log(item);

                                        if (that.AnswerMsg.includes('评分维度总结(雷达图):**')) {
                                            that.AnswerMsg = that.AnswerMsg + item.answer;
                                            const index = that.AnswerMsg.lastIndexOf('评分维度总结(雷达图):**');
                                            const lastAnswer = that.AnswerMsg.substring(index + 1);
                                            // 查找 'axis' 和 '本次表现' 的位置
                                            const axisIndex = lastAnswer.indexOf('axis');
                                            const performanceIndex = lastAnswer.indexOf('本次表现');
                                            // 截取从 'axis' 到 '本次表现' 之前的部分
                                            const firstPart = lastAnswer.slice(axisIndex + 'axis'.length, performanceIndex).trim();
                                            // 将第一部分转换为数组
                                            const firstArray = firstPart.split(/\s+/);
                                            // 截取从 '本次表现' 开始到结尾的部分
                                            const secondPart = lastAnswer.slice(performanceIndex + '本次表现'.length).trim();
                                            // 去掉冒号和引号，然后转换为数组
                                            const secondArray = secondPart.replace(/[" :]/g, '').split(',');
                                            console.log(firstArray);
                                            console.log(secondArray);
                                            this.firstArray = firstArray;
                                            this.secondArray = secondArray;
                                        } else if (that.AnswerMsg.includes('客户:')) {
                                            const newStr = that.AnswerMsg.replace(/^客户: /, '');
                                            console.log(newStr);
                                            const Last_text = newStr + item.answer;
                                            const html = md.render(Last_text);
                                            that.diaArr[that.diaArr.length - 1].conter = html;
                                            that.AnswerMsg = newStr + item.answer;
                                            that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                            that.query = '';
                                        } else {
                                            const Last_text = that.AnswerMsg + item.answer;
                                            const html = md.render(Last_text);
                                            console.log(Last_text);
                                            that.diaArr[that.diaArr.length - 1].conter = html;
                                            that.AnswerMsg = that.AnswerMsg + item.answer;
                                            that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                            that.query = '';
                                        }
                                    }
                                    if (item.content[0].event_type == 'chatflow') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1;
                                        console.log(item);

                                        if (that.AnswerMsg.includes('评分维度总结(雷达图):**')) {
                                            that.AnswerMsg = that.AnswerMsg + item.answer;
                                            const index = that.AnswerMsg.lastIndexOf('评分维度总结(雷达图):**');
                                            const lastAnswer = that.AnswerMsg.substring(index + 1);
                                            // 查找 'axis' 和 '本次表现' 的位置
                                            const axisIndex = lastAnswer.indexOf('axis');
                                            const performanceIndex = lastAnswer.indexOf('本次表现');
                                            // 截取从 'axis' 到 '本次表现' 之前的部分
                                            const firstPart = lastAnswer.slice(axisIndex + 'axis'.length, performanceIndex).trim();
                                            // 将第一部分转换为数组
                                            const firstArray = firstPart.split(/\s+/);
                                            // 截取从 '本次表现' 开始到结尾的部分
                                            const secondPart = lastAnswer.slice(performanceIndex + '本次表现'.length).trim();
                                            // 去掉冒号和引号，然后转换为数组
                                            const secondArray = secondPart.replace(/[" :]/g, '').split(',');
                                            console.log(firstArray);
                                            console.log(secondArray);
                                            this.firstArray = firstArray;
                                            this.secondArray = secondArray;
                                        } else if (that.AnswerMsg.includes('客户:')) {
                                            const newStr = that.AnswerMsg.replace(/^客户: /, '');
                                            console.log(newStr);
                                            const Last_text = newStr + item.answer;
                                            const html = md.render(Last_text);
                                            that.diaArr[that.diaArr.length - 1].conter = html;
                                            that.AnswerMsg = newStr + item.answer;
                                            that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                            that.query = '';
                                        } else {
                                            const Last_text = that.AnswerMsg + item.answer;
                                            const html = md.render(Last_text);
                                            console.log(Last_text);
                                            that.diaArr[that.diaArr.length - 1].conter = html;
                                            that.AnswerMsg = that.AnswerMsg + item.answer;
                                            that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                            that.query = '';
                                        }
                                    }
                                    if (item.content[0].event_type == 'RAGAgent') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        const Last_text = that.AnswerMsg + item.answer;
                                        const html = md.render(Last_text);
                                        that.diaArr[that.diaArr.length - 1].conter = html;
                                        that.AnswerMsg = that.AnswerMsg + item.answer;
                                        that.query = '';
                                        if (item.content[0].outputs.references.length > 0) {
                                            const references_arr = [];
                                            item.content[0].outputs.references.forEach((itemValue, itemIndex) => {
                                                const str = {
                                                    index: itemValue.id,
                                                    content: itemValue.content,
                                                    dataset_name: itemValue.dataset_name,
                                                    document_name: itemValue.document_name,
                                                    document_id: itemValue.document_id,
                                                }
                                                references_arr.push(str)
                                            })
                                            that.diaArr[that.diaArr.length - 1].fileList = references_arr
                                            that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        }

                                        // that.autoScroll()
                                    }

                                    that.mergeArr = []
                                    that.isMerge = false;
                                } else if (item && item.is_completion) {
                                    reader.releaseLock();
                                    clearInterval(that.timeID)
                                    // that.AnswerIndex = 0;
                                    // that.ThinkIndex = 0;
                                    // that.ThinkMsg = '';
                                    // that.AnswerMsg = '';
                                    that.diaArr[that.diaArr.length - 1].stop = true;
                                    that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                    that.loadingText = '';
                                    that.isOpen = false;
                                    that.loadingNums = 0;
                                    that.query = '';
                                    that.btnDisabled = false;
                                    that.mergeArr = []
                                    that.isMerge = false;
                                    var yuamrAnswerEvaluate = {};
                                    if (that.firstArray.length > 0) {
                                        console.log('11111');
                                        that.firstArray.splice(that.firstArray.length - 1, 1);
                                        yuamrAnswerEvaluate = [{
                                            firstArray: that.firstArray,
                                            secondArray: that.secondArray
                                        }]
                                    }
                                    addYcAiTrainUserMsg({
                                        yatuId: that.WxAiChatSession.yatuId,
                                        yuamrQuestion: that.diaArr[that.diaArr.length - 2].conter,
                                        yuamrAnswer: that.diaArr[that.diaArr.length - 1].conter,
                                        yuamrAnswerEvaluate: yuamrAnswerEvaluate ? JSON.stringify(yuamrAnswerEvaluate) : ''
                                    }).then(res => {
                                        if (res.data.yatuStatus == 2) {
                                            var yuamrAnswerEvaluate = JSON.parse(res.data.yuamrAnswerEvaluate)
                                            if (yuamrAnswerEvaluate[0].firstArray && yuamrAnswerEvaluate[0].firstArray.length > 0) {
                                                that.firstArray = yuamrAnswerEvaluate[0].firstArray;
                                                that.secondArray = yuamrAnswerEvaluate[0].secondArray;
                                                that.echartsStrValue = {
                                                    xdata: [],
                                                    data: []
                                                };
                                                that.$nextTick(() => {
                                                    that.initEcharts()
                                                })
                                                that.isTraining = 2;
                                            }
                                        }
                                    })
                                }
                            })

                        }
                    } else {
                        var lines = chunk.split('\n'); // 假设每个数据项占一行，且用换行符分隔  
                        var dataItems = lines.filter(line => line.startsWith('data: '));
                        if (that.DmxIndex == 0) {
                            console.log(decoder);
                            that.diaArr.splice(that.diaArr.length - 1, 1);
                            const AiMsg = {
                                type: 1,
                                HanderImg: "https://txcloud.aojuai.com/icon/aojv/icon/ai.png",
                                conter: that.AnswerMsg,
                                FollowUpQuery: [],
                                think: '',
                                stop: false,
                                IsCollapse: true,
                                IsFlieShow: false,

                            }
                            that.diaArr.push(AiMsg);
                            clearInterval(that.timeID)
                            that.isOpen = true;
                            that.loadingText = '.';
                            that.loadingNums = 0;
                            // that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                        }
                        try {
                            var jsonObjects = dataItems.map(item => {
                                // 移除每行开头的 "data: "
                                // console.log(item);  
                                var jsonString = item.substring(6);
                                // 将JSON字符串转换为对象  
                                return JSON.parse(jsonString);
                            });
                            // console.log(jsonObjects);
                            jsonObjects.forEach((item, index) => {
                                if (!item.is_completion) {
                                    // console.log(item.content[0].event_type );
                                    if (item.content[0].event_type == 'ChatAgent') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1;
                                        console.log(item);

                                        if (that.AnswerMsg.includes('评分维度总结(雷达图):**')) {
                                            that.AnswerMsg = that.AnswerMsg + item.answer;
                                            const index = that.AnswerMsg.lastIndexOf('评分维度总结(雷达图):**');
                                            const lastAnswer = that.AnswerMsg.substring(index + 1);
                                            // 查找 'axis' 和 '本次表现' 的位置
                                            const axisIndex = lastAnswer.indexOf('axis');
                                            const performanceIndex = lastAnswer.indexOf('本次表现');
                                            // 截取从 'axis' 到 '本次表现' 之前的部分
                                            const firstPart = lastAnswer.slice(axisIndex + 'axis'.length, performanceIndex).trim();
                                            // 将第一部分转换为数组
                                            const firstArray = firstPart.split(/\s+/);
                                            // 截取从 '本次表现' 开始到结尾的部分
                                            const secondPart = lastAnswer.slice(performanceIndex + '本次表现'.length).trim();
                                            // 去掉冒号和引号，然后转换为数组
                                            const secondArray = secondPart.replace(/[" :]/g, '').split(',');
                                            console.log(firstArray);
                                            console.log(secondArray);
                                            this.firstArray = firstArray;
                                            this.secondArray = secondArray;
                                        } else if (that.AnswerMsg.includes('客户:')) {
                                            const newStr = that.AnswerMsg.replace(/^客户: /, '');
                                            console.log(newStr);
                                            const Last_text = newStr + item.answer;
                                            const html = md.render(Last_text);
                                            that.diaArr[that.diaArr.length - 1].conter = html;
                                            that.AnswerMsg = newStr + item.answer;
                                            that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                            that.query = '';
                                        } else {
                                            const Last_text = that.AnswerMsg + item.answer;
                                            const html = md.render(Last_text);
                                            console.log(Last_text);
                                            that.diaArr[that.diaArr.length - 1].conter = html;
                                            that.AnswerMsg = that.AnswerMsg + item.answer;
                                            that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                            that.query = '';
                                        }
                                    }
                                    if (item.content[0].event_type == 'chatflow') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1;
                                        console.log(item);

                                        if (that.AnswerMsg.includes('评分维度总结(雷达图):**')) {
                                            that.AnswerMsg = that.AnswerMsg + item.answer;
                                            const index = that.AnswerMsg.lastIndexOf('评分维度总结(雷达图):**');
                                            const lastAnswer = that.AnswerMsg.substring(index + 1);
                                            // 查找 'axis' 和 '本次表现' 的位置
                                            const axisIndex = lastAnswer.indexOf('axis');
                                            const performanceIndex = lastAnswer.indexOf('本次表现');
                                            // 截取从 'axis' 到 '本次表现' 之前的部分
                                            const firstPart = lastAnswer.slice(axisIndex + 'axis'.length, performanceIndex).trim();
                                            // 将第一部分转换为数组
                                            const firstArray = firstPart.split(/\s+/);
                                            // 截取从 '本次表现' 开始到结尾的部分
                                            const secondPart = lastAnswer.slice(performanceIndex + '本次表现'.length).trim();
                                            // 去掉冒号和引号，然后转换为数组
                                            const secondArray = secondPart.replace(/[" :]/g, '').split(',');
                                            console.log(firstArray);
                                            console.log(secondArray);
                                            this.firstArray = firstArray;
                                            this.secondArray = secondArray;
                                        } else if (that.AnswerMsg.includes('客户:')) {
                                            const newStr = that.AnswerMsg.replace(/^客户: /, '');
                                            console.log(newStr);
                                            const Last_text = newStr + item.answer;
                                            const html = md.render(Last_text);
                                            that.diaArr[that.diaArr.length - 1].conter = html;
                                            that.AnswerMsg = newStr + item.answer;
                                            that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                            that.query = '';
                                        } else {
                                            const Last_text = that.AnswerMsg + item.answer;
                                            const html = md.render(Last_text);
                                            console.log(Last_text);
                                            that.diaArr[that.diaArr.length - 1].conter = html;
                                            that.AnswerMsg = that.AnswerMsg + item.answer;
                                            that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                            that.query = '';
                                        }
                                    }
                                    if (item.content[0].event_type == 'RAGAgent') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        const Last_text = that.AnswerMsg + item.answer;
                                        // console.log(Last_text);
                                        const html = md.render(Last_text);
                                        that.diaArr[that.diaArr.length - 1].conter = html;
                                        that.AnswerMsg = that.AnswerMsg + item.answer;
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        that.query = '';
                                    }

                                } else if (item.is_completion) {
                                    reader.releaseLock();
                                    clearInterval(that.timeID)
                                    that.AnswerIndex = 0;
                                    that.ThinkIndex = 0;
                                    that.ThinkMsg = '';
                                    that.AnswerMsg = '';
                                    that.diaArr[that.diaArr.length - 1].stop = true;
                                    that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                    that.loadingText = '';
                                    that.isOpen = false;
                                    that.loadingNums = 0;
                                    that.query = '';
                                    that.btnDisabled = false;
                                    var yuamrAnswerEvaluate = {};
                                    if (that.firstArray.length > 0) {
                                        console.log('11111');
                                        that.firstArray.splice(that.firstArray.length - 1, 1);
                                        yuamrAnswerEvaluate = [{
                                            firstArray: that.firstArray,
                                            secondArray: that.secondArray
                                        }]
                                    }
                                    addYcAiTrainUserMsg({
                                        yatuId: that.WxAiChatSession.yatuId,
                                        yuamrQuestion: that.diaArr[that.diaArr.length - 2].conter,
                                        yuamrAnswer: that.diaArr[that.diaArr.length - 1].conter,
                                        yuamrAnswerEvaluate: yuamrAnswerEvaluate ? JSON.stringify(yuamrAnswerEvaluate) : ''
                                    }).then(res => {
                                        if (res.data.yatuStatus == 2) {
                                            var yuamrAnswerEvaluate = JSON.parse(res.data.yuamrAnswerEvaluate)
                                            if (yuamrAnswerEvaluate[0].firstArray && yuamrAnswerEvaluate[0].firstArray.length > 0) {
                                                that.firstArray = yuamrAnswerEvaluate[0].firstArray;
                                                that.secondArray = yuamrAnswerEvaluate[0].secondArray;
                                                that.echartsStrValue = {
                                                    xdata: [],
                                                    data: []
                                                };
                                                that.$nextTick(() => {
                                                    that.initEcharts()
                                                })
                                                that.isTraining = 2

                                            }
                                        }
                                    })
                                }
                            })
                        } catch (e) {
                            console.error("解析JSON时出错：", e, chunk);
                            clearInterval(that.timeID)
                            that.mergeArr.push(chunk)
                            that.loadingNums = 0;
                            that.loadingText = '';
                            that.isMerge = true;
                        }
                    }

                }
            } catch (error) {
                if (error.name === 'AbortError') {
                    console.log('请求已中断');
                } else {
                    console.error('请求出错:', error);
                }
            } finally {
                this.controller = null;
            }


        },
        async requestTask_api_Init(val) {
            var that = this
            const str = {
                app_id: that.WxAiChatSession.appId,
                conversation_id: that.WxAiChatSession.conversationId,
                stream: true,
                query: val,
            }
            that.controller = new AbortController();
            const signal = that.controller.signal;
            try {
                // const response = await fetch(that.api_url +'/v2/app/conversation/runs', {
                // const response = await fetch('/api/v2/app/conversation/runs', {
                const response = await fetch('https://trainuser.aojuai.com/api/v2/app/conversation/runs', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json',
                        'X-Appbuilder-Authorization': that.WxAiChatSession.appSecret,
                    },
                    body: JSON.stringify(str), // 对象转为 JSON 字符串
                    // credentials: 'include',
                    // mode: 'no-cors',
                    signal
                })
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const reader = response.body.getReader(); // 获取流式读取器
                const decoder = new TextDecoder(); // 解码二进制数据为文本

                // console.log(decoder);
                while (true) {
                    const { done, value } = await reader.read(); // 逐块读取
                    if (done) break; // 流结束
                    const chunk = decoder.decode(value); // 解码为文本
                    // console.log('Received chunk:', chunk);
                    if (that.isMerge) {
                        that.mergeArr.push(chunk);
                        const mergeStr = that.mergeArr.join('');
                        var lines2 = mergeStr.split('\n'); // 假设每个数据项占一行，且用换行符分隔  
                        var dataItems2 = lines2.filter(line => line.startsWith('data: '));
                        var jsonObjects2 = dataItems2.map(item => {
                            // 移除每行开头的 "data: "
                            var jsonString2 = item.substring(6);
                            try {
                                // 将JSON字符串转换为对象  
                                return JSON.parse(jsonString2);
                            } catch (e) {
                                console.error("解析JSON时出错：", e, item);
                                return null;
                            }
                            // 将JSON字符串转换为对象  
                        });
                        if (jsonObjects2.length > 0) {
                            console.log(jsonObjects2);
                            jsonObjects2.forEach((item, index) => {
                                if (item && !item.is_completion) {

                                    if (item.content[0].event_type == 'ChatAgent') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        const Last_text = that.AnswerMsg + item.answer;
                                        const html = md.render(Last_text);
                                        that.diaArr[that.diaArr.length - 1].conter = html;
                                        that.AnswerMsg = that.AnswerMsg + item.answer;
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        that.query = '';
                                    }
                                    if (item.content[0].event_type == 'chatflow') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        const Last_text = that.AnswerMsg + item.answer;
                                        const html = md.render(Last_text);
                                        that.diaArr[that.diaArr.length - 1].conter = html;
                                        that.AnswerMsg = that.AnswerMsg + item.answer;
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        that.query = '';
                                    }
                                    that.mergeArr = []
                                    that.isMerge = false;
                                } else if (item && item.is_completion) {
                                    reader.releaseLock();
                                    clearInterval(that.timeID)
                                    // that.AnswerIndex = 0;
                                    // that.ThinkIndex = 0;
                                    // that.ThinkMsg = '';
                                    // that.AnswerMsg = '';
                                    that.diaArr[that.diaArr.length - 1].stop = true;
                                    that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                    that.loadingText = '';
                                    that.isOpen = false;
                                    that.loadingNums = 0;
                                    that.query = '';
                                    that.btnDisabled = false;
                                    that.mergeArr = []
                                    that.isMerge = false;
                                    addYcAiTrainUserMsg({
                                        yatuId: that.WxAiChatSession.yatuId,
                                        yuamrQuestion: val,
                                        yuamrAnswer: that.diaArr[that.diaArr.length - 1].conter,
                                    })
                                }
                            })

                        }
                    } else {
                        var lines = chunk.split('\n'); // 假设每个数据项占一行，且用换行符分隔  
                        var dataItems = lines.filter(line => line.startsWith('data: '));
                        try {
                            var jsonObjects = dataItems.map(item => {
                                // 移除每行开头的 "data: "
                                // console.log(item);  
                                var jsonString = item.substring(6);
                                // 将JSON字符串转换为对象  
                                return JSON.parse(jsonString);
                            });
                            // console.log(jsonObjects);
                            jsonObjects.forEach((item, index) => {
                                if (!item.is_completion) {
                                    // console.log(item.content[0].event_type );
                                    if (item.content[0].event_type == 'ChatAgent') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        const Last_text = that.AnswerMsg + item.answer;
                                        const html = md.render(Last_text);
                                        that.diaArr[that.diaArr.length - 1].conter = html;
                                        that.AnswerMsg = that.AnswerMsg + item.answer;
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        that.query = '';
                                        // console.log(item.answer);

                                        // that.autoScroll()
                                    }
                                    if (item.content[0].event_type == 'RAGAgent') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        const Last_text = that.AnswerMsg + item.answer;
                                        // console.log(Last_text);
                                        const html = md.render(Last_text);
                                        that.diaArr[that.diaArr.length - 1].conter = html;
                                        that.AnswerMsg = that.AnswerMsg + item.answer;
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        that.query = '';
                                    }
                                    if (item.content[0].event_type == 'chatflow') {
                                        that.AnswerIndex = that.AnswerIndex + 1
                                        that.DmxIndex = that.DmxIndex + 1
                                        // console.log(that.DmxIndex);
                                        const Last_text = that.AnswerMsg + item.answer;
                                        const html = md.render(Last_text);
                                        that.diaArr[that.diaArr.length - 1].conter = html;
                                        that.AnswerMsg = that.AnswerMsg + item.answer;
                                        that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                        that.query = '';
                                    }

                                } else if (item.is_completion) {
                                    clearInterval(that.timeID)
                                    that.AnswerIndex = 0;
                                    that.ThinkIndex = 0;
                                    that.ThinkMsg = '';
                                    that.AnswerMsg = '';
                                    that.diaArr[that.diaArr.length - 1].stop = true;
                                    that.$set(that.diaArr, that.diaArr.length - 1, that.diaArr[that.diaArr.length - 1])
                                    that.loadingText = '';
                                    that.isOpen = false;
                                    that.loadingNums = 0;
                                    that.query = '';
                                    that.btnDisabled = false;
                                    addYcAiTrainUserMsg({
                                        yatuId: that.WxAiChatSession.yatuId,
                                        yuamrQuestion: val,
                                        yuamrAnswer: that.diaArr[that.diaArr.length - 1].conter,
                                    }).then(res => {
                                        reader.releaseLock();
                                    })
                                }
                            })
                        } catch (e) {
                            console.error("解析JSON时出错：", e, chunk);
                            clearInterval(that.timeID)
                            that.mergeArr.push(chunk)
                            that.loadingNums = 0;
                            that.loadingText = '';
                            that.isMerge = true;
                        }
                    }

                }
            } catch (error) {
                if (error.name === 'AbortError') {
                    console.log('请求已中断');
                } else {
                    console.error('请求出错:', error);
                }
            } finally {
                that.controller = null;
            }


        },
        // requestTask_api(val) {
        //     var that = this
        //     const str = {
        //         app_id: that.WxAiChatSession.aaAppId,
        //         conversation_id: that.WxAiChatSession.conversationId,
        //         stream: true,
        //         query: val,
        //     }
        //     const s = qs.stringify(str)
        //     axios({
        //         method: 'post',
        //         url: " https://qianfan.baidubce.com/v2/app/conversation/runs",
        //         data: s,
        //         withCredentials: false,
        //         timeout: 1200000,
        //         responseType: 'stream',
        //         headers: {
        //             'content-type': 'application/json',
        //             'X-Appbuilder-Authorization': that.WxAiChatSession.appSecret,
        //         }
        //     }).then(function (res) {
        //             console.log(res.data.data);

        //     })
        // },
        // 将html转纯文本
        convertHtmlToText: function convertHtmlToText(inputText) {
            var returnText = "" + inputText;
            returnText = returnText.replace(/<\/div>/ig, '\r\n');
            returnText = returnText.replace(/<\/li>/ig, '\r\n');
            returnText = returnText.replace(/<li>/ig, ' * ');
            returnText = returnText.replace(/<\/ul>/ig, '\r\n');
            //-- remove BR tags and replace them with line break
            returnText = returnText.replace(/<br\s*[\/]?>/gi, "\r\n");

            //-- remove P and A tags but preserve what's inside of them
            returnText = returnText.replace(/<p.*?>/gi, "\r\n");
            returnText = returnText.replace(/<a.*href="(.*?)".*>(.*?)<\/a>/gi, " $2 ($1)");

            //-- remove all inside SCRIPT and STYLE tags
            returnText = returnText.replace(/<script.*>[\w\W]{1,}(.*?)[\w\W]{1,}<\/script>/gi, "");
            returnText = returnText.replace(/<style.*>[\w\W]{1,}(.*?)[\w\W]{1,}<\/style>/gi, "");
            //-- remove all else
            returnText = returnText.replace(/<(?:.|\s)*?>/g, "");

            //-- get rid of more than 2 multiple line breaks:
            returnText = returnText.replace(/(?:(?:\r\n|\r|\n)\s*){2,}/gim, "\r\n\r\n");

            //-- get rid of more than 2 spaces:
            returnText = returnText.replace(/ +(?= )/g, '');

            //-- get rid of html-encoded characters:
            returnText = returnText.replace(/&nbsp;/gi, " ");
            returnText = returnText.replace(/&amp;/gi, "&");
            returnText = returnText.replace(/&quot;/gi, '"');
            returnText = returnText.replace(/&lt;/gi, '<');
            returnText = returnText.replace(/&gt;/gi, '>');

            return returnText;
        },
        // 收起or展开 思考
        collapseTap(index) {
            this.diaArr[index].IsCollapse = !this.diaArr[index].IsCollapse
            this.$set(this.diaArr, index, this.diaArr[index])
        },
        // 收起or展开 参考资料
        collapseFileTap(index) {
            this.diaArr[index].IsFlieShow = !this.diaArr[index].IsFlieShow
            this.$set(this.diaArr, index, this.diaArr[index])
        },
        theTrainingChange(item) {
            this.isTraining = 0;
            this.theItem = item;
            this.theYatbId = item.yatbId;
        },
        // 初始化
        createInit() {
            var that = this
            this.$confirm('是否确认开始训练', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                addYcAiTrainUser({ yatbId: that.theYatbId }).then(res => {
                    that.isTraining = 1;//0未训练，1开始训练,2训练结束
                    that.controller = null;
                    that.diaArr = [{
                        type: 4, //1.是答,2.是问
                        stop: false,
                        HanderImg: "https://txcloud.aojuai.com/icon/aojv/icon/ai.png",
                        conter: '......',
                        stop: false,
                    }];
                    that.WxAiChatSession = res.data;
                    if (res.data.yatbBaseQuestions) {
                        that.requestTask_api_Init(res.data.yatbBaseQuestions)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消'
                });
            });
        },
        // 登录
        ...mapMutations(['changeuser']),
        handleSubmit() {
            if (this.userAccount == '' || this.password == '') {
                this.$message({
                    showClose: true,
                    message: '请输入账号和密码',
                    type: 'danger'
                });
                return
            }
            doLoginAiTrain({
                userAccount: this.userAccount,
                password: this.password
            }).then(res => {
                if (res.status == 200) {
                    this.$message({
                        showClose: true,
                        message: '登录成功',
                        type: 'success'
                    });
                    this.changeuser({ userMsg: res.data })
                    this.isLogin = false;
                    getUserProjectRecordLast({ userId: res.data.userId }).then(ress => {
                        let msg = JSON.parse(localStorage.getItem('AiTrainingMsg'))
                        msg.projectId = ress.data.projectId;
                        msg.projectName = ress.data.projectName;
                        this.changeuser({ userMsg: msg });
                        if (this.tabsIndex == '1') {
                            this.MyTrainRecord()
                        } else {
                            this.AiSCenc()
                        }
                        // this.createInit()
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'danger'
                    });
                }
            });
        },

        // 输入框提交事件
        inputSub() {
            if (this.query == '') {
                this.$message({
                    showClose: true,
                    message: '请输入内容',
                    type: 'danger'
                });
                return
            }
            const myMsg = {
                type: 2,
                conter: this.query
            }
            const load = {
                type: 3,
                conter: '我正在努力思考，请稍等',
                stop: false,
            }
            this.diaArr.push(myMsg)
            this.diaArr.push(load)
            this.getTime();
            this.DmxInit(this.query)
        },
        keyDown(e) {
            //console.log(e)
            if (e.key == 'Enter') {
                this.inputSub();
                e.preventDefault()//去掉默认的换行
            }
        },
        getTime() {
            var that = this
            that.timeID = setInterval(() => {
                if (that.loadingNums >= 4) {
                    that.loadingNums = 0;
                    that.loadingText = '.'
                }
                that.loadingNums = that.loadingNums + 1,
                    that.loadingText = that.loadingText + '.'

            }, 400) //每隔1s调用一次timer函数
        },
    }
}
</script>

<style scoped>
.zhushou_title {
    width: 50%;
}

.zhushou_img {
    width: 80px;
    height: 80px;
    margin: 0 10px;
}

.zhushou_center {
    width: 95%;
    height: 120px;
    background-color: #F1F6FF;
    display: flex;
    margin: 10px auto 10px;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
}

div /deep/ .el-collapse-item__content {
    padding-bottom: 0px !important;
}

div /deep/ .el-tabs--border-card {
    background: none !important;
    height: 100% !important;
}

div /deep/ .el-tabs--border-card>.el-tabs__content {
    padding: 0px !important;
    height: 100% !important;
}

.img_type1 {
    width: 100px;
    height: 100px;
    position: absolute;
    top: -40px;
    left: 10px;
}

.mainDivHeight {
    height: calc(100% - 100px) !important;
}

.mainDiv::-webkit-scrollbar {
    display: none;
}

.mainDivHeight::-webkit-scrollbar {
    display: none;
}

.egclass {
    position: relative;
    max-width: 90%;
    margin: 20px 10px 10px;
    padding: 35px 10px 10px;
    /* background-image: url('https://txcloud.aojuai.com/icon/aojv/aiwx_icon/dhk.png'); */
    /* background-repeat: no-repeat; */
    /* background-color: #D3DFFE; */
    /* background-size: cover; */
    font-size: 16px;
    border-radius: 30px 30px 30px 0;
    /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}

.message {
    position: relative;
    max-width: 98%;
    margin: 10px;
    padding: 10px;
    /* background-color: #D3DFFE; */
    /* background: linear-gradient(to bottom, #accdf1, white); */
    font-size: 22rpx;
    /* display: flex; */
    /* z-index: 10; */
}

.login-container {
    max-width: 400px;
    margin: 50px auto;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    font-family: 'Arial', sans-serif;

}

h2 {
    text-align: center;
    color: #333333;
    font-size: 24px;
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 20px;
}

label {
    display: block;
    margin-bottom: 5px;
    color: #555555;
    font-weight: bold;
}

input {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    border: 1px solid #cccccc;
    border-radius: 5px;
    font-size: 16px;
    transition: border-color 0.3s, box-shadow 0.3s;
}

input:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25);
}

button {
    width: 100%;
    padding: 12px;
    background-color: #42b983;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;
}

button:hover {
    background-color: #36956f;
}

.egTitleclass {
    font-size: 21px;
    font-weight: bold;
    position: absolute;
    top: 0px;
    left: 10px;
}

.inputDiv {
    width: calc(100% - 500px - 25%);
    min-height: 130px;
    position: fixed;
    bottom: 20px;
    left: calc(500px + 12%);
    border-radius: 15px;
    border: 1px solid #DCDFE6;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.inputDiv div /deep/ .el-textarea__inner {
    border: none !important;
    resize: none !important;
}

.iconStyle {
    width: 40px;
    height: 40px;
    margin: 10px;
    font-size: 22px;
}

.iconStyle_icon {
    width: 20px;
    height: 20px;
}

.flex-right {
    flex-direction: row-reverse;
}

.flex-right>.message::after {
    left: unset;
    right: -5px;
}

.message2 {
    position: relative;
    max-width: 98%;
    margin: 10px;
    padding: 10px;
    background: linear-gradient(to right, #6299FE, #1159E6);
    border-radius: 10px 10px 0 10px;
    font-size: 16px;
    /* display: flex; */
    /* z-index: 10; */
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.aoju_title {
    width: calc(100% - 15%);
    font-size: 26px;
    font-weight: 600;
}

@media (max-width: 600px) {
    .aoju_title {
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

    }

    .inputDiv {
        width: 95%;
        min-height: 80px;
        position: fixed;
        bottom: 10px;
        left: 2.5%;
        border-radius: 15px;
        border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }

    .egTitleclass {
        font-size: 16px;
        font-weight: bold;
        position: absolute;
        top: 0px;
        left: 10px;
    }

    .mainDiv {
        width: 100% !important;
        height: calc(100% - 100px) !important;

    }

    .login-container {
        padding: 30px;
    }

    h2 {
        font-size: 20px;
    }

    input,
    button {
        font-size: 14px;
        padding: 10px;
    }

    .egclass {
        position: relative;
        max-width: 98% !important;
        margin: 20px 0px 0px;
        padding: 25px 10px 10px;
        /* background-image: url('https://txcloud.aojuai.com/icon/aojv/aiwx_icon/dhk.png'); */
        /* background-repeat: no-repeat; */
        /* background-color: #D3DFFE; */
        /* background-size: cover; */
        font-size: 12px;
        border-radius: 30px 30px 30px 0;
        /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
    }

    .message2 {
        position: relative;
        max-width: 98%;
        margin: 10px;
        padding: 10px;
        background: linear-gradient(to right, #6299FE, #1159E6);
        border-radius: 5px 5px 0 5px;
        font-size: 10px !important;
        /* display: flex; */
        /* z-index: 10; */
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    /* 确保没有不必要的外部边距或填充 */
    ol,
    ul,
    dl {
        padding-left: 20px !important;
        /* 移除默认的左填充 */
        margin: 0;
        /* 移除默认的外边距 */
    }

    .message {
        position: relative;
        max-width: 98%;
        margin: 10px;
        padding: 10px;
        /* padding-left: 15px !important; */
        /* background-color: #D3DFFE; */
        /* background: linear-gradient(to bottom, #accdf1, white); */
        /* border-radius: 30px 30px 30px 0; */
        font-size: 10px !important;
        /* display: flex; */
        /* z-index: 10; */
        overflow: auto;
        /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
    }

}
</style>
